import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { AiOutlineFolderOpen } from "react-icons/ai";
import { FaXmark } from "react-icons/fa6";

const fields = ["Admin", "SubAdmin", "ID", "User", "Admin"];
const conditions = ["Sum", "Count", "Avg"];

function AddGroup() {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState([
    { field: "", condition: "", value: "" },
  ]);

  const handleChange = (index, type, value) => {
    const updated = [...filters];
    updated[index][type] = value;
    setFilters(updated);
  };

  const handleDelete = (index) => {
    const updated = [...filters];
    updated.splice(index, 1);
    setFilters(updated);
  };

  return (
    <div>
      <div className="group relative cursor-pointer">
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content="Add Group"
          className="text-sm bg-gray-200 text-gray-500 shadow-sm font-semibold rounded-md px-3 py-1.5 flex gap-1 items-center justify-center text-center border border-transparent hover:text-gray-800 transition-all"
          onClick={() => setIsOpen(!isOpen)}
        >
          <AiOutlineFolderOpen size={18} />
          AddGroup
        </div>

        {isOpen && (
          <div
            className="absolute right-0 z-50 mt-2 w-[480px] bg-white shadow-lg border rounded-md text-sm p-4"
            onMouseLeave={() => setIsOpen(false)}
          >
            {/* Dynamic Filters */}
            {filters.map((filter, index) => (
              <div
                key={index}
                className="flex items-center justify-between gap-2 mb-2"
              >
                {/* Field Select */}
                <select
                  className="border px-2 py-1 outline-none rounded w-1/3"
                  value={filter.field}
                  onChange={(e) => handleChange(index, "field", e.target.value)}
                >
                  <option value="">Select</option>
                  {fields.map((field, idx) => (
                    <>
                      {" "}
                      <option key={idx} value={field}>
                        {field}
                      </option>
                    </>
                  ))}
                </select>

                {/* Condition Select */}
                <select
                  className="border px-2 py-1 outline-none rounded w-1/3"
                  value={filter.condition}
                  onChange={(e) =>
                    handleChange(index, "condition", e.target.value)
                  }
                >
                  <option value="">Select</option>
                  {conditions.map((cond, idx) => (
                    <option key={idx} value={cond}>
                      {cond}
                    </option>
                  ))}
                </select>

                {/* Value Select */}
                <select
                  className="border px-2 py-1 outline-none rounded w-1/3"
                  value={filter.value}
                  onChange={(e) => handleChange(index, "value", e.target.value)}
                >
                  <option value="">Select</option>
                  {fields.map((val, idx) => (
                    <option key={idx} value={val}>
                      {val}
                    </option>
                  ))}
                </select>

                {/* Delete Button */}
                {filters.length > 1 && (
                  <button
                    onClick={() => handleDelete(index)}
                    className="text-black cursor-pointer"
                  >
                    <FaXmark size={18} />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Tooltip */}
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />
    </div>
  );
}

export default AddGroup;